export enum SaveTargetKind {
  STANDARD_MEAL = 'standard_meal',
  ACTION_TUNNEL = 'action_tunnel',
}
